<div class="">
  <div class="row">
    <div class="col-md-12">
      <app-main-content-project></app-main-content-project>
    </div>
  </div>
</div>
